module.exports = __webpack_public_path__ + "static/media/foodtransport4.d7b86fb5.jpg";